function TextBanner() {
    $PrevSelectedDesktop = $("#AnoncementArea ul.desktopSlide li.selectedBannerDesktop")
    $PrevSelectedDesktop.removeClass("selectedBannerDesktop")

    if ($("#AnoncementArea ul.desktopSlide li").length != $PrevSelectedDesktop.index() + 1) {
        $PrevSelectedDesktop.next().addClass("selectedBannerDesktop");
    } else {
        $("#AnoncementArea ul.desktopSlide li").first().addClass("selectedBannerDesktop");
    }

    $PrevSelectedMobile = $("#AnoncementArea ul.mobileSlide li.selectedBannerMobile")
    $PrevSelectedMobile.removeClass("selectedBannerMobile")

    if ($("#AnoncementArea ul.mobileSlide li").length != $PrevSelectedMobile.index() + 1) {
        $PrevSelectedMobile.next().addClass("selectedBannerMobile");
    } else {
        $("#AnoncementArea ul.mobileSlide li").first().addClass("selectedBannerMobile");
    }
}

function settingTextBanner() {
    setInterval(TextBanner, 7000);
}

function GetLayoutTextBanners() {
    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: getRequestRoute() + "/p/Home/GetTextBannerList",
        success: function (dt) {
            if (dt.length > 0) {
                var desktopCounter = 0;
                var mobileCounter = 0;
                for (var i = 0; i < dt.length; i++) {
                    if (dt[i].Area == 12) {
                        if (desktopCounter == 0) {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        } else {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        }
                    } else {
                        if (mobileCounter == 0) {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md selectedBannerMobile'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        } else {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        }
                    }
                }
            }

            settingTextBanner();
        }
    });
}

$(document).ready(function () {
    settingTextBanner();
    //GetLayoutTextBanners();

    if (!isMobileResolution()) {
        $("#HomeBannerSection .SBanner").each(function (index) {
            if ($(this).find(".mobile-section").length > 0) {
                caruselInner = $(this).find(".mobile-section").closest(".carousel-inner");

                //$(this).find(".mobile-section").closest(".carousel-item").remove();
                caruselInner.find(".carousel-item").first().addClass("active");
            }

            //if ($(this).find(".carousel-inner .carousel-item").length <= 1) {
            //    $(this).find("> a").remove();
            //}
        });
    }
    else {
        $("#HomeBannerSection .SBanner").each(function (index) {
            if ($(this).find(".desktop-section").length > 0) {
                caruselInner = $(this).find(".desktop-section").closest(".carousel-inner");    
                
                //$(this).find(".desktop-section").closest(".carousel-item").remove();
                caruselInner.find(".carousel-item").first().addClass("active");
            }

            //if ($(this).find(".carousel-inner .carousel-item").length <= 1) {
            //    $(this).find("> a").remove();
            //}
        });
    }
    if ($(window).width() <= 991) {
        $('.bottomMenu p').click(function () {
            $(this).parent().toggleClass("open");
        });
    }

    //if ($(window).width() <= 767) {
    //    if ((".ProductList .Prd").length > 4) {
    //        $(".ProductList .Prd").last().remove();
    //    }
    //}
    if (isMobileResolution() && $("#HomeBannerSection .ProductList .Prd").length > 4) {
        $("#HomeBannerSection .ProductList .Prd").last().remove();
    }
   
    $(document).on("click", "#Anasayfa1 .ScrollDown i", function () {
        var height = $("#HomeBannerSection #Anasayfa1").height();

        $("html, body").animate({ scrollTop: height }, 500, 'swing');
    });
});

$(window).load(function () {
    $(".UseLazyLoad").Lazy();
    $(".ProductList .Prd img.PImage, .ProductList .Prd .ProductListColor img").Lazy();
});